// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fict","left":"styles_left__1rtox"};